module.exports = __webpack_public_path__ + "static/media/rack-wallpaper2.b9521f22.jpg";